
function checkInViewSections() {
  const sections = document.querySelectorAll('[data-inview]');

  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    const isInView = rect.top <= window.innerHeight && rect.bottom >= 0;
    const activeClass = section.dataset.inview;

    if (isInView) {
      section.classList.add(activeClass);
    } else {
      section.classList.remove(activeClass);
    }
  });
}

window.addEventListener('scroll', checkInViewSections);
window.addEventListener('resize', checkInViewSections);

// Initial check
checkInViewSections();

// same height function
function applyEqualHeightsToSection(wrapperClass, targetClass) {
  var sections = document.querySelectorAll(wrapperClass);

  sections.forEach(function (section) {
    var elements = section.querySelectorAll(targetClass);
    var maxHeight = 0;

    // Reset height before recalculating
    elements.forEach(function (el) {
      el.style.minHeight = 'auto';
    });

    // Find max height
    elements.forEach(function (el) {
      var height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Apply max height
    elements.forEach(function (el) {
      el.style.minHeight = maxHeight + 'px';
    });
  });
}

// List of wrapper and target class pairs
const sectionsToApply = [
  { wrapper: '.testimonial-slider', target: '.testimonial-card ' },
];

// Run on load and resize
function applyAllEqualHeights() {
  sectionsToApply.forEach(({ wrapper, target }) => {
    applyEqualHeightsToSection(wrapper, target);
  });
}

window.addEventListener('load', applyAllEqualHeights);
window.addEventListener('resize', function () {
  window.requestAnimationFrame(applyAllEqualHeights);
});
